import { useMutation, UseMutationOptions } from 'react-query';
import { amplifyApiClient } from '@/utility/amplify';
import type { ErrorResponse } from 'api-response';

type ApiMethod = 'post' | 'put' | 'del';

interface UseAmplifyMutationProps<TData, TVariables = void, TError = ErrorResponse> {
  method: ApiMethod;
  apiName: string;
  path: string;
  mutationOptions?: UseMutationOptions<TData, TError, TVariables>;
}

export function useAmplifyMutation<
  TData = any,
  TVariables = void,
  TError = ErrorResponse
>({
  method,
  apiName,
  path,
  mutationOptions,
}: UseAmplifyMutationProps<TData, TVariables, TError>) {
  return useMutation<TData, TError, TVariables>({
    mutationFn: async (variables: TVariables) => {
      return amplifyApiClient(method, apiName, path, {
        ...(variables && { body: variables }),
      });
    },
    ...mutationOptions,
  });
}
